<template>
  <div class="assessments-main-wrapper">
    <div
      v-if="!CurrentTourQuestionsJSON || CurrentTourQuestionsJSON.length == 0"
    >
      <h3 style="font-weight: 900; font-size: 41px">Hold tight ...</h3>
      <br />
      {{ QuestionsToGenerateFor.Title }}
      We are generating some questions to help you identify your progress...<br />
    </div>
    <div
      v-else-if="
        CurrentTourQuestionsJSON &&
        CurrentTourQuestionsJSON.length > 0 &&
        QuestionsAnswered < CurrentTourQuestionsJSON.length
      "
    >
      <div
        v-for="(question, questionIdx) in CurrentTourQuestionsJSON"
        :key="questionIdx"
      >
        <div v-if="!question.answered" class="question-wrapper">
          <h3>{{ question.t }}</h3>
          <div
            v-for="(answer, answerIdx) in question.a"
            :key="answerIdx"
            @click="toggleAnswer(question, answer)"
          >
            <div class="answer-wrapper" v-if="!answer.hidden">
              <div class="answer-text">
                {{ answer.t }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="QuestionsAnswered == CurrentTourQuestionsJSON.length"
      style="width: 320px; margin: 0 auto"
    >
      <img
        src="@/assets/images/pages/assessment-complete.jpg"
        alt="Tour complete"
        class="mx-auto mb-4 max-w-full"
        style="height: 338px; width: 338px"
      />
      <h1 style="font-weight: 900">You made it!</h1>
      <span style="float: left">Thank you so much for the efforts.</span
      ><br /><br /><br />
      <vs-button
        @click="
          CurrentTourQuestionsJSON = null;
          $emit('ModeChanged', '');
        "
        >Close tour</vs-button
      >
    </div>
    <vs-button @click="$emit('ModeChanged', '')" v-if="false">Finish</vs-button>
  </div>
</template>
<script>
import AssignmentService from "@/assignments/assignmentsService.js";
import AIUtils from "./utils/AIUtils.js";

export default {
  data() {
    return {
      CurrentTourQuestionsJSON: null,
      QuestionsAnswered: null,
      minAttempts: null,
      attempts: null,
    };
  },
  methods: {
    ...AIUtils,
    toggleAnswer(question, answer, win) {

      win = win || window;

      if (win) {
        win.scrollTo(0, 0);
      }

      if (answer.c) {
        this.QuestionsAnswered++;
        this.$set(question, "answered", true);
      } else {
        alert("Ok, this wasn't quite it.\nLet's try again.");
        this.$set(answer, "hidden", true);
      }

      AssignmentService.assignTopicQuizAnswer(
        question.tid,
        "DataModel.TCVelik.Embed.TCEmbed",
        answer.c
      );
    },
  },
  mounted() {
    this.$nextTick(function () {
      window.scrollTo(0, 0);
    });

    var instance = this;
    if (this.QuestionsToGenerateFor && this.QuestionsToGenerateFor.length > 0) {
      this.GenerateQuestions(
        this.QuestionsToGenerateFor,
        this.QuestionsToGenerateFor[0].Id
      ).then(function (response) {
        instance.$set(instance, "CurrentTourQuestionsJSON", response);
      });
    }
  },
  props: ["QuestionsToGenerateFor"],
};
</script>
<style scoped>
.assessments-main-wrapper {
  max-width: 95%;
}

.question-wrapper {
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 10px;
  color: var(--primary)
}

.hamburger .question-wrapper h3 {
  font-size: 1.2em !important;
  margin-bottom: 30px;
}

.hamburger .answer-text {
  font-size: 0.8em !important;
}

.question-wrapper h3 {
  color: var(--primary);
  font-weight: 900;
  font-size: 2.2em;
  margin-bottom: 50px;
}

.answer-wrapper {
  width: 100%;
  display: block;
  padding: 5px;
  margin: 5px;
  cursor: pointer;
  border: 1px solid var(--primary);
  color: var(--primary);
  border-radius: 10px;
  font-size:1.5em;
}
</style>
